import { ReactElement, useEffect, useState } from 'react'
import { TableRow, BranchFilterSection, BranchAction } from '../subcomponents'
import {
  SectionTitle,
  TableWrapper,
  TableHeader,
  TableFooter,
  Modal,
  FlexWrapper,
  Loader,
  PageWrapper,
  Button
} from '../../../../components'
import strings from '../../../../locale/en'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import {
  deleteBranch,
  getAvailableCourses,
  getBranchById,
  getBranchList,
  getInstitutes
} from '../../../../redux/coachingCenter/actions'
import { RootState } from '../../../../redux/store'
import { Branch } from '../../../../redux/coachingCenter/types'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'
import { getInstituteDropdown } from '../../../../helpers'
import { ROLE } from '../../../../helpers/determineMenu'
import { FormBackWrapper } from '../../User/subcomponents'

const BranchList = (): ReactElement => {
  const {
    institutes = [],
    branches,
    isLoading,
    role,
    userDetail
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      branches: state.coachingCenter.branchList,
      isLoading: state.coachingCenter.isLoading,
      role: state.user.userInfo?.role,
      userDetail: state.user?.userInfo?.userDetail
    }),
    shallowEqual
  )

  const history = useHistory()
  const dispatch = useDispatch()
  const [deleteBranchId, setDeleteBranchId] = useState('')
  const [coachingCentreId, setCoachingCentreId] = useState(
    userDetail?.coachingCenterId || ''
  )
  const { branchList, pageNumber = 1, totalPages = 1 } = branches || {}

  const {
    menu: {
      branch: { branchListing, add }
    },
    modal: { deleteRecord }
  } = strings

  const institutesDropdown = getInstituteDropdown(institutes)

  useEffect(() => {
    if (role === ROLE.INSTITUTE_ADMIN) {
      dispatch(
        getBranchList({
          coachingCentreId: coachingCentreId,
          pageNo: pageNumber
        })
      )
    } else {
      dispatch(getInstitutes())
      dispatch(getBranchList({ pageNo: 1, coachingCentreId }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={branchListing} />
        <Button onClick={() => history.push(ROUTES.BRANCH_ADD)}>{add}</Button>
      </FlexWrapper>
      {role === ROLE.ADMIN && (
        <BranchFilterSection
          institueList={institutesDropdown}
          handleinstituteSelect={(institue) => {
            setCoachingCentreId(institue?.id)
            dispatch(
              getBranchList({
                coachingCentreId: institue?.id,
                pageNo: pageNumber
              })
            )
          }}
        />
      )}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div>
            <FormBackWrapper>
              <TableWrapper>
                <Table responsive="sm" size="sm">
                  <TableHeader>
                    <TableRow>
                      {tableHeader?.map((header, index) => (
                        <th key={`branch-list-header-${index}`}>{header}</th>
                      ))}
                    </TableRow>
                  </TableHeader>
                  <tbody>
                    {branchList?.map((branch: Branch, index) => (
                      <TableRow key={`branch-${index}`}>
                        <td>{branch?.branchName}</td>
                        <td>{branch?.city}</td>
                        <td>{branch?.zipCode}</td>
                        <td>{branch?.mobileNumber}</td>
                        <td>{branch?.email}</td>
                        <td>{branch?.isMainBranch}</td>
                        <td>{branch?.questionLimit}</td>
                        <td>{branch?.status}</td>
                        <td>
                          <BranchAction
                            handleEdit={() => {
                              dispatch(
                                getAvailableCourses(branch?.coachingCenterId)
                              )
                              dispatch(getBranchById(branch?.id))
                              history.push(ROUTES.BRANCH_EDIT)
                            }}
                            handleView={() => {
                              dispatch(
                                getAvailableCourses(branch?.coachingCenterId)
                              )
                              dispatch(getBranchById(branch?.id))
                              history.push(ROUTES.BRANCH_DETAIL)
                            }}
                            handleDelete={() => setDeleteBranchId(branch.id)}
                          />
                        </td>
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
                <TableFooter
                  currentPage={pageNumber}
                  totalPages={totalPages}
                  handleNext={() =>
                    dispatch(
                      getBranchList({ pageNo: pageNumber + 1, coachingCentreId })
                    )
                  }
                  handlePrevious={() =>
                    dispatch(
                      getBranchList({ pageNo: pageNumber - 1, coachingCentreId })
                    )
                  }
                />
              </TableWrapper>
            </FormBackWrapper>
          </div>
        </>
      )}
      {deleteBranchId && (
        <Modal
          handleCancel={() => {
            setDeleteBranchId('')
          }}
          handleSubmit={() => {
            dispatch(deleteBranch(deleteBranchId))
            setDeleteBranchId('')
          }}
          title={deleteRecord}
        />
      )}
    </PageWrapper>
  )
}

export default BranchList
